/**
 * `/settings/notifications` — the per-event preference surface.
 *
 * One `RouteObject`, so the file is `notifications.route.tsx` (singular). No
 * `loader` performs a data read; the page component owns its reads.
 */
import type { RouteObject } from 'react-router-dom';

export const notificationSettingsRoute: RouteObject = {
  path: 'settings/notifications',
  lazy: async () => {
    const { NotificationSettingsPage } = await import('./Notifications');
    return { Component: NotificationSettingsPage };
  },
};
